export const EXAM_LANDING_PAGES = {
  "ssc-cgl-typing-test": {
    slug: "ssc-cgl-typing-test",
    title: "SSC CGL Typing Test 2025 — Syllabus, WPM & Free Practice | Typogram",
    metaDescription:
      "Complete SSC CGL typing test guide: qualifying speed, English/Hindi rules, backspace policy, and free online practice on Typogram.",
    keywords:
      "SSC CGL typing test, SSC CGL skill test, CGL typing speed, SSC typing practice, free typing test",
    h1: "SSC CGL Typing Test Preparation",
    exam: "SSC CGL",
    wpm: "35 WPM English (typical qualifying target; confirm in official notice)",
    stage: "Tier skill test after mains",
    category: "SSC",
    intro:
      "The SSC CGL typing skill test is the final hurdle for many posts. Typogram helps you build exam-day speed and accuracy with free typing tests and SSC-pattern mock passages.",
    faqs: [
      {
        q: "What WPM is required for SSC CGL typing test?",
        a: "Speed targets vary by post and notification year. Many candidates prepare for around 35 WPM in English as a baseline — always verify the latest SSC notice for your specific post.",
      },
      {
        q: "Is Hindi typing required for SSC CGL?",
        a: "Some posts require Hindi typing in Kruti Dev or similar layouts. Check your post's skill test specification in the official notification.",
      },
      {
        q: "How can I practice SSC CGL typing online free?",
        a: "Use Typogram's free typing test and SSC CGL courses to practice timed passages, track WPM, and improve accuracy daily.",
      },
    ],
  },
  "ssc-chsl-typing-test": {
    slug: "ssc-chsl-typing-test",
    title: "SSC CHSL Typing Test 2025 — Format, Speed & Practice | Typogram",
    metaDescription:
      "SSC CHSL typing test preparation: expected WPM, accuracy rules, Kruti Dev/Mangal Hindi typing, and free mock tests on Typogram.",
    keywords:
      "SSC CHSL typing test, CHSL skill test, CHSL typing speed, Hindi typing SSC, free typing test",
    h1: "SSC CHSL Typing Test Preparation",
    exam: "SSC CHSL",
    wpm: "35 WPM English (planning benchmark; verify official notice)",
    stage: "Skill test stage",
    category: "CHSL",
    intro:
      "SSC CHSL candidates must pass a typing/data entry skill test for LDC, DEO, and related posts. Build consistent WPM and near-perfect accuracy with structured daily practice on Typogram.",
    faqs: [
      {
        q: "What is the SSC CHSL typing test format?",
        a: "Candidates type a printed passage on computer within a time limit. Errors and backspace rules depend on the notification — practice under timed conditions on Typogram.",
      },
      {
        q: "Kruti Dev or Mangal for CHSL Hindi typing?",
        a: "Confirm the font specified in your exam notification. Typogram supports Hindi typing practice so you can adapt before the skill test.",
      },
      {
        q: "How many hours should I practice daily?",
        a: "Most successful candidates practice 45–60 minutes daily: warm-up drills, timed passage, and error review.",
      },
    ],
  },
  "rrb-typing-test": {
    slug: "rrb-typing-test",
    title: "RRB Typing Test Guide — NTPC, Ministerial & JE Skill Test | Typogram",
    metaDescription:
      "RRB typing test preparation for NTPC, ministerial, and isolated categories. Learn WPM targets, common errors, and practice free on Typogram.",
    keywords:
      "RRB typing test, RRB NTPC typing, RRB skill test, railway typing test, free typing test",
    h1: "RRB Typing Test Preparation",
    exam: "RRB NTPC / Ministerial / Isolated",
    wpm: "30–40 WPM depending on post and category",
    stage: "Computer-based skill test",
    category: "RRB",
    intro:
      "Railway recruitment typing tests reward accuracy under pressure. Whether you are preparing for RRB NTPC, ministerial, or isolated category posts, Typogram gives you exam-style practice with real-time WPM tracking.",
    faqs: [
      {
        q: "What typing speed is needed for RRB NTPC?",
        a: "Speed requirements differ by post. Prepare for 30–40 WPM as a working range and confirm your specific category in the RRB notification.",
      },
      {
        q: "Does RRB typing test allow backspace?",
        a: "Rules vary by exam cycle. Practice both accuracy-first typing and timed passages so you are ready either way.",
      },
      {
        q: "Where can I take a free RRB typing mock test?",
        a: "Start at typogram.in/typing-display and explore RRB-focused courses for structured preparation.",
      },
    ],
  },
  "ibps-typing-test": {
    slug: "ibps-typing-test",
    title: "IBPS Typing Test — PO, Clerk & SO Skill Test Practice | Typogram",
    metaDescription:
      "IBPS typing test guide for PO, clerk, and specialist officer posts. Practice WPM, accuracy, and descriptive typing on Typogram.",
    keywords:
      "IBPS typing test, IBPS clerk typing, IBPS PO skill test, banking typing test, free typing test",
    h1: "IBPS Typing Test Preparation",
    exam: "IBPS (PO / Clerk / SO)",
    wpm: "Post-specific; skill test when notified",
    stage: "Skill or DEST where applicable",
    category: "Banking",
    intro:
      "IBPS and participating banks may include typing or data entry skill tests for clerical and specialist posts. Typogram helps banking aspirants build speed, punctuation accuracy, and exam stamina.",
    faqs: [
      {
        q: "Is typing test mandatory for IBPS clerk?",
        a: "When notified, clerical posts may include a skill test. Always read the current IBPS advertisement for your cycle.",
      },
      {
        q: "What should I focus on for banking typing tests?",
        a: "Accuracy, number/numeric passages, and consistent WPM under time pressure. Practice daily on Typogram's timed tests.",
      },
      {
        q: "Can I practice IBPS typing test online for free?",
        a: "Yes — use Typogram's free typing test and banking exam courses.",
      },
    ],
  },
  "banking-typing-test": {
    slug: "banking-typing-test",
    title: "Banking Exam Typing Test — SBI, IBPS, RBI Practice | Typogram",
    metaDescription:
      "Banking exam typing test preparation for SBI, IBPS, RBI, and regional rural banks. Free WPM tests and structured courses on Typogram.",
    keywords:
      "banking typing test, SBI typing test, bank exam skill test, typing for bank jobs, free typing test",
    h1: "Banking Exam Typing Test",
    exam: "SBI / IBPS / RBI / RRB (Banking)",
    wpm: "Varies by bank and post notification",
    stage: "Skill test when specified",
    category: "Banking",
    intro:
      "Banking sector skill tests often combine English typing, data entry, and accuracy checks. Typogram offers free typing tests and banking-focused courses to help you qualify with confidence.",
    faqs: [
      {
        q: "Do all bank jobs require a typing test?",
        a: "No — only posts that specify a skill or typing test in the official notification. Check SBI, IBPS, or RBI notices for your role.",
      },
      {
        q: "How to improve typing speed for bank exams?",
        a: "Practice 45 minutes daily: finger drills, timed passages, and review of error patterns. Track WPM weekly on Typogram.",
      },
      {
        q: "Is Typogram free for banking typing practice?",
        a: "Yes — start with the free typing test at typogram.in/typing-display and upgrade to courses if you want structured prep.",
      },
    ],
  },
  "hindi-typing-test": {
    slug: "hindi-typing-test",
    title: "Hindi Typing Test Online Free — Kruti Dev & Mangal Practice | Typogram",
    metaDescription:
      "Free Hindi typing test online. Practice Kruti Dev and Mangal layouts, check WPM and accuracy, and prepare for SSC CHSL and government Hindi skill tests on Typogram.",
    keywords:
      "hindi typing test, hindi typing online, kruti dev typing, mangal typing, hindi WPM test, hindi typing practice",
    h1: "Hindi Typing Test Online",
    exam: "Hindi Typing (SSC / State PSC)",
    wpm: "25–35 WPM typical for Hindi skill tests (verify notification)",
    stage: "Skill / typing test where Hindi is required",
    category: "CHSL",
    intro:
      "Hindi typing is a core skill test for SSC CHSL, state PSC, and many clerical posts. Typogram helps you practice Kruti Dev or Unicode Hindi layouts with timed tests and accuracy tracking.",
    faqs: [
      {
        q: "Kruti Dev या Mangal — कौन सा फॉन्ट CHSL में आता है?",
        a: "Official notification में font specify होता है। Typogram पर दोनों layouts की practice कर सकते हैं।",
      },
      {
        q: "How to check Hindi typing speed online?",
        a: "Take a free Hindi typing test at typogram.in/typing-display and track WPM plus error rate over time.",
      },
      {
        q: "What is a good Hindi typing speed for government exams?",
        a: "Many notifications target 25–35 WPM in Hindi. Build accuracy first, then speed with daily 45-minute practice.",
      },
    ],
  },
  "typing-speed-test": {
    slug: "typing-speed-test",
    title: "Typing Speed Test Online — Check WPM Free | Typogram",
    metaDescription:
      "Free typing speed test online. Measure WPM, accuracy, and errors instantly. Practice daily and improve typing speed for exams and jobs on Typogram.",
    keywords:
      "typing speed test, WPM test, typing speed test online, check typing speed, words per minute test, free WPM test",
    h1: "Typing Speed Test Online",
    exam: "All learners & exam aspirants",
    wpm: "40+ WPM is a strong general target; exams may require 30–35 WPM minimum",
    stage: "Daily practice & benchmarking",
    category: "Typing Tips",
    intro:
      "A typing speed test (WPM test) measures how many words you type per minute with accuracy. Whether you are preparing for SSC, RRB, banking exams, or improving office skills, Typogram's free test gives instant results.",
    faqs: [
      {
        q: "What is a good typing speed (WPM)?",
        a: "For general use, 40–50 WPM is solid. Government typing tests often require 30–35 WPM minimum — always check your exam notification.",
      },
      {
        q: "How is WPM calculated?",
        a: "WPM is typically based on characters typed divided by 5, adjusted for errors depending on exam rules. Typogram shows live WPM and accuracy.",
      },
      {
        q: "How can I improve typing speed in 30 days?",
        a: "Practice 45–60 minutes daily: home-row drills, timed passages, and weekly mock tests. Track progress on Typogram's free typing speed test.",
      },
    ],
  },
  "upsssc-typing-test": {
    slug: "upsssc-typing-test",
    title: "UPSSSC Typing Test — PET, LDC & Clerk Skill Test Guide | Typogram",
    metaDescription:
      "UPSSSC typing test preparation for PET, LDC, clerk, and assistant posts. Hindi & English WPM targets, practice plan, and free online tests on Typogram.",
    keywords:
      "UPSSSC typing test, UPSSSC PET typing, UP LDC typing test, UPSSSC skill test, hindi typing UP",
    h1: "UPSSSC Typing Test Preparation",
    exam: "UPSSSC (Uttar Pradesh)",
    wpm: "Notification-specific; prepare for Hindi & English skill tests",
    stage: "Skill test after PET / mains as applicable",
    category: "SSC",
    intro:
      "UPSSSC recruits for LDC, clerk, assistant, and PET-qualified posts that may include Hindi or English typing skill tests. Typogram offers free practice aligned with timed exam conditions.",
    faqs: [
      {
        q: "Does UPSSSC PET include a typing test?",
        a: "Typing requirements depend on the specific post and notification. Read the official UPSSSC advertisement for your vacancy.",
      },
      {
        q: "Hindi or English typing for UPSSSC?",
        a: "Many UP posts require Hindi typing in Kruti Dev or similar. Confirm font and speed in the official notice.",
      },
      {
        q: "Where to practice UPSSSC typing online?",
        a: "Use Typogram's free typing test and UP-focused courses for daily timed practice.",
      },
    ],
  },
  "delhi-police-typing-test": {
    slug: "delhi-police-typing-test",
    title: "Delhi Police Typing Test — Head Constable & Ministerial Guide | Typogram",
    metaDescription:
      "Delhi Police typing test preparation for head constable, ministerial, and clerk posts. WPM targets, Hindi/English rules, and free mock tests on Typogram.",
    keywords:
      "Delhi Police typing test, Delhi Police head constable typing, Delhi Police skill test, typing test Delhi",
    h1: "Delhi Police Typing Test",
    exam: "Delhi Police (HC / Ministerial)",
    wpm: "Typically 30–35 WPM (confirm in notification)",
    stage: "Skill / typing test stage",
    category: "SSC",
    intro:
      "Delhi Police recruitment for ministerial and head constable posts often includes a computer typing skill test. Build speed, accuracy, and exam stamina with Typogram's free typing tests.",
    faqs: [
      {
        q: "What typing speed is required for Delhi Police?",
        a: "Speed varies by post and year. Use 30–35 WPM as a planning benchmark and verify the latest Delhi Police notification.",
      },
      {
        q: "Is Hindi typing required for Delhi Police?",
        a: "Some posts require Hindi typing. Check whether Kruti Dev or Mangal is specified in your exam syllabus.",
      },
      {
        q: "How to prepare for Delhi Police typing test?",
        a: "Daily timed mocks on Typogram, focus on accuracy, and simulate exam duration without pauses.",
      },
    ],
  },
  "delhi-police-head-constable-typing-test": {
    slug: "delhi-police-head-constable-typing-test",
    title: "Delhi Police Head Constable Typing Test 2025 — Skill Test Guide | Typogram",
    metaDescription:
      "Delhi Police Head Constable typing test preparation: expected WPM, English and Hindi skill test rules, and free online practice on Typogram.",
    keywords:
      "Delhi Police head constable typing test, Delhi Police HC typing, Delhi Police ministerial typing, Delhi Police skill test",
    h1: "Delhi Police Head Constable Typing Test Preparation",
    exam: "Delhi Police Head Constable",
    wpm: "Usually 30–35 WPM depending on recruitment notice",
    stage: "Computer typing / skill test stage",
    category: "SSC",
    intro:
      "Delhi Police Head Constable and ministerial recruitments often include a typing or computer skill test. Typogram helps you practice timed passages, improve accuracy, and build the confidence needed for police recruitment typing rounds.",
    faqs: [
      {
        q: "What typing speed is required for Delhi Police Head Constable?",
        a: "The required speed depends on the official Delhi Police recruitment notification. Many candidates prepare in the 30–35 WPM range as a safe benchmark.",
      },
      {
        q: "Is the Delhi Police Head Constable typing test in English or Hindi?",
        a: "That depends on the post and official rules. Some recruitments specify English typing, while some may include Hindi or ministerial computer skill requirements.",
      },
      {
        q: "How should I prepare for Delhi Police Head Constable typing test?",
        a: "Practice timed mocks daily, track WPM and mistakes, and simulate the pressure of the actual skill test using Typogram's free typing platform.",
      },
    ],
  },
  "police-constable-typing-test": {
    slug: "police-constable-typing-test",
    title: "Police Constable Typing Test 2025 — Skill Test Guide & Practice | Typogram",
    metaDescription:
      "Police constable typing test preparation for head constable, ministerial, clerk, and computer operator posts. WPM targets, Hindi/English rules, and free practice on Typogram.",
    keywords:
      "police constable typing test, constable typing test, police typing test, head constable typing test, police ministerial typing",
    h1: "Police Constable Typing Test Preparation",
    exam: "Police Constable / Head Constable / Ministerial",
    wpm: "Typically 25–35 WPM depending on force and notification",
    stage: "Computer typing / skill test stage",
    category: "SSC",
    intro:
      "Police constable and head constable recruitments in multiple states can include a typing or computer skill test for ministerial, clerk, and operator roles. Typogram helps you practice timed passages, improve typing accuracy, and prepare for real exam pressure.",
    faqs: [
      {
        q: "Is typing test required for police constable jobs?",
        a: "Only for specific police constable, head constable, ministerial, clerk, or operator posts that mention a typing or computer skill test in the official notification.",
      },
      {
        q: "What typing speed is needed for police constable typing test?",
        a: "Speed targets vary by recruitment board. Many candidates prepare in the 25–35 WPM range, but you should verify the latest official notice for your force and post.",
      },
      {
        q: "How can I practice police constable typing online free?",
        a: "Use Typogram's free typing test and exam-style timed practice to build WPM, reduce mistakes, and simulate the actual typing skill test.",
      },
    ],
  },
  "bsf-head-constable-typing-test": {
    slug: "bsf-head-constable-typing-test",
    title: "BSF Head Constable Typing Test 2025 — Ministerial Skill Test Guide | Typogram",
    metaDescription:
      "BSF Head Constable typing test preparation for ministerial and clerical posts. Learn likely WPM targets, exam format, and practice free online on Typogram.",
    keywords:
      "BSF head constable typing test, BSF HC ministerial typing, BSF typing test, BSF skill test, BSF clerk typing",
    h1: "BSF Head Constable Typing Test Preparation",
    exam: "BSF Head Constable / Ministerial",
    wpm: "Typically 30–35 WPM depending on official BSF notice",
    stage: "Typing / skill test after written stage",
    category: "SSC",
    intro:
      "BSF Head Constable Ministerial and similar posts can include a qualifying typing skill test. Typogram helps BSF aspirants build speed, reduce errors, and practice under timed exam-style conditions before the real recruitment round.",
    faqs: [
      {
        q: "What typing speed is required for BSF Head Constable?",
        a: "Speed requirements vary by BSF recruitment cycle and post. Many candidates prepare for around 30–35 WPM in English unless the notification states otherwise.",
      },
      {
        q: "Is BSF Head Constable typing test mandatory?",
        a: "For ministerial and clerical posts where the official BSF notification lists a typing or computer skill test, it is an important qualifying stage.",
      },
      {
        q: "Where can I practice BSF Head Constable typing online free?",
        a: "Use Typogram's free typing test and timed practice tools to simulate the BSF typing skill test and improve accuracy before exam day.",
      },
    ],
  },
  "ldc-typing-test": {
    slug: "ldc-typing-test",
    title: "LDC Typing Test — SSC CHSL & Government Clerk Skill Test | Typogram",
    metaDescription:
      "LDC typing test guide for SSC CHSL and government clerk posts. Data entry speed, accuracy rules, and free online LDC typing practice on Typogram.",
    keywords:
      "LDC typing test, CHSL LDC typing, clerk typing test, data entry skill test, LDC skill test",
    h1: "LDC Typing Test Preparation",
    exam: "LDC / Clerk (SSC CHSL & State)",
    wpm: "~35 WPM English common benchmark for CHSL LDC",
    stage: "Skill test after qualifying tiers",
    category: "CHSL",
    intro:
      "Lower Division Clerk (LDC) posts under SSC CHSL and state exams require a qualifying typing or data entry skill test. Typogram helps you hit target WPM with structured daily practice.",
    faqs: [
      {
        q: "What is the LDC typing test in SSC CHSL?",
        a: "Candidates type a passage on computer within a time limit. Errors and backspace rules follow SSC notification — practice under timed conditions.",
      },
      {
        q: "What WPM is needed for LDC typing test?",
        a: "Many CHSL LDC notices target around 35 WPM in English. Confirm the current SSC CHSL skill test specification.",
      },
      {
        q: "Can I practice LDC typing test online free?",
        a: "Yes — start at typogram.in/typing-display and use CHSL courses for exam-pattern passages.",
      },
    ],
  },
  "sbi-clerk-typing-test": {
    slug: "sbi-clerk-typing-test",
    title: "SBI Clerk Typing Test — Skill Test Guide & Practice | Typogram",
    metaDescription:
      "SBI Clerk typing and data entry skill test preparation. WPM targets, exam format, and free online practice for SBI JA recruitment on Typogram.",
    keywords: "SBI clerk typing test, SBI JA skill test, SBI typing test, clerk data entry test",
    h1: "SBI Clerk Typing Test",
    exam: "SBI Clerk (Junior Associate)",
    wpm: "Notification-specific; often 35 WPM English",
    stage: "Skill / typing test when notified",
    category: "Banking",
    intro:
      "SBI Clerk recruitment may include a typing or data entry skill test depending on the cycle. Typogram helps you build consistent speed and accuracy before the skill test stage.",
    faqs: [
      { q: "Is typing test mandatory for SBI Clerk?", a: "Only when specified in the official SBI Clerk notification for that year. Always read the latest advertisement." },
      { q: "What speed is required for SBI Clerk typing?", a: "Varies by cycle — prepare for 30–35 WPM in English as a baseline and verify the official notice." },
      { q: "Where to practice SBI Clerk typing online?", a: "Use Typogram's free typing test and banking exam courses for timed mock passages." },
    ],
  },
  "railway-ntpc-typing-test": {
    slug: "railway-ntpc-typing-test",
    title: "Railway NTPC Typing Test — RRB Skill Test Guide | Typogram",
    metaDescription:
      "RRB NTPC typing test preparation for ministerial and isolated posts. WPM requirements, practice plan, and free mock tests on Typogram.",
    keywords: "railway NTPC typing test, RRB NTPC skill test, NTPC typing speed, railway typing test",
    h1: "Railway NTPC Typing Test",
    exam: "RRB NTPC",
    wpm: "30–40 WPM depending on post category",
    stage: "CBT followed by skill/typing test where applicable",
    category: "RRB",
    intro:
      "RRB NTPC recruitment for certain ministerial and isolated categories includes a computer-based typing skill test. Prepare with exam-pattern timed tests on Typogram.",
    faqs: [
      { q: "Which RRB NTPC posts have typing tests?", a: "Posts in ministerial and isolated categories as listed in the official RRB NTPC notification — not all NTPC posts require typing." },
      { q: "What is the NTPC typing test format?", a: "Typically a timed passage on computer. Error and backspace rules follow the official RRB skill test guidelines." },
      { q: "How to prepare for railway NTPC typing?", a: "Daily 45-minute practice on Typogram with weekly full-length mock skill tests under exam conditions." },
    ],
  },
  "state-psc-typing-test": {
    slug: "state-psc-typing-test",
    title: "State PSC Typing Test — Clerk & Assistant Skill Test | Typogram",
    metaDescription:
      "State PSC typing test guide for clerk, assistant, and LDC posts across India. Hindi and English WPM targets and free practice on Typogram.",
    keywords: "state PSC typing test, PSC clerk typing, state government typing test, LDC skill test",
    h1: "State PSC Typing Test",
    exam: "State PSC (UP, Bihar, MP, Rajasthan, etc.)",
    wpm: "Varies by state notification — often 30–35 WPM",
    stage: "Skill test after written exam",
    category: "SSC",
    intro:
      "State Public Service Commission exams for clerk, assistant, and data entry posts often include Hindi or English typing skill tests. Typogram supports both layouts with free timed practice. See state-specific guides for UPPSC, BPSC, MPPSC, and RPSC.",
    faqs: [
      { q: "Do all state PSC exams have typing tests?", a: "No — only posts that list a skill or typing test in the official state PSC notification." },
      { q: "Hindi or English for state PSC typing?", a: "Depends on the state and post. Many northern states require Hindi typing in Kruti Dev or Unicode layouts." },
      { q: "How to prepare for state PSC typing test?", a: "Identify your state's WPM target from the notification, then practice daily on Typogram's free typing test." },
    ],
  },
  "free-online-typing-test": {
    slug: "free-online-typing-test",
    title: "Free Online Typing Test — No Sign Up WPM Check | Typogram",
    metaDescription:
      "Take a free online typing test with no sign-up required. Check WPM, accuracy, and errors instantly. Practice for SSC, RRB, and banking exams on Typogram.",
    keywords: "free online typing test, typing test online free, free WPM test, typing test no registration, online typing practice free",
    h1: "Free Online Typing Test",
    exam: "All users — exams & general practice",
    wpm: "Track your own progress; exams often need 30–35 WPM",
    stage: "Instant practice anytime",
    category: "Typing Tips",
    intro:
      "Typogram offers a free online typing test you can start immediately. Measure words per minute (WPM), accuracy, and error count — ideal for exam prep or office skill improvement.",
    faqs: [
      { q: "Is Typogram typing test really free?", a: "Yes — you can take typing tests at typogram.in/typing-display with core features free. Create an account to save progress." },
      { q: "Do I need to download software?", a: "No — Typogram runs in your browser on desktop and mobile." },
      { q: "Can I use this for SSC and RRB exam prep?", a: "Yes — timed tests and exam-pattern courses are designed for government typing skill tests." },
    ],
  },
  "data-entry-typing-test": {
    slug: "data-entry-typing-test",
    title: "Data Entry Typing Test — Speed & Accuracy Guide | Typogram",
    metaDescription:
      "Data entry typing test preparation for government clerk, LDC, and operator posts. Accuracy rules, WPM targets, and free practice on Typogram.",
    keywords: "data entry typing test, data entry skill test, data entry operator typing, typing test for data entry jobs",
    h1: "Data Entry Typing Test",
    exam: "Clerk / LDC / Data Entry Operator",
    wpm: "Often 8,000–10,000 KDPH or 35 WPM equivalent (verify notice)",
    stage: "Skill test stage",
    category: "CHSL",
    intro:
      "Data entry skill tests measure how fast and accurately you type structured text — common in SSC CHSL, state clerk, and operator recruitment. Typogram builds both speed and precision.",
    faqs: [
      { q: "What is a data entry skill test?", a: "A timed test where you type given text on computer; errors may be penalized per official exam rules." },
      { q: "How is data entry speed measured?", a: "Exams may use KDPH (key depressions per hour) or WPM. Check your specific notification." },
      { q: "Best way to prepare for data entry test?", a: "Practice numeric and alphanumeric passages daily on Typogram with focus on accuracy above 95%." },
    ],
  },
  "uppsc-typing-test": {
    slug: "uppsc-typing-test",
    title: "UPPSC Typing Test — UP PCS Clerk & Assistant Skill Test | Typogram",
    metaDescription:
      "UPPSC typing test preparation for UP PCS clerk, assistant, and review officer posts. Hindi and English WPM targets, exam format, and free practice on Typogram.",
    keywords: "UPPSC typing test, UP PCS typing test, UP clerk typing test, UPPSC skill test, UP typing test Hindi",
    h1: "UPPSC Typing Test Preparation",
    exam: "UPPSC (Uttar Pradesh PSC)",
    wpm: "Often 25–35 WPM Hindi or English (verify notification)",
    stage: "Skill / typing test after mains or interview stage",
    category: "SSC",
    intro:
      "UPPSC recruitment for clerk, assistant, and similar posts often includes a qualifying Hindi or English typing skill test. Typogram helps UP aspirants build speed with Kruti Dev and Unicode Hindi layouts plus English timed mocks.",
    faqs: [
      { q: "Does UPPSC have a typing test?", a: "Many UPPSC clerk and assistant notifications include a computer typing skill test. Always check your specific post's official advertisement." },
      { q: "Hindi or English typing for UPPSC?", a: "UP posts frequently require Hindi typing in Kruti Dev or Mangal. Some posts accept English — confirm in the UPPSC notification." },
      { q: "What WPM is needed for UPPSC typing test?", a: "Targets vary by post and year. Prepare for 25–35 WPM in your required language and verify the latest UPPSC notice." },
    ],
  },
  "bpsc-typing-test": {
    slug: "bpsc-typing-test",
    title: "BPSC Typing Test — Bihar PSC Clerk Skill Test Guide | Typogram",
    metaDescription:
      "BPSC typing test preparation for Bihar PSC clerk, assistant, and stenographer posts. Hindi typing WPM targets and free online practice on Typogram.",
    keywords: "BPSC typing test, Bihar PSC typing test, Bihar clerk typing test, BPSC skill test, Bihar Hindi typing",
    h1: "BPSC Typing Test Preparation",
    exam: "BPSC (Bihar PSC)",
    wpm: "Typically 25–30 WPM Hindi for clerk posts",
    stage: "Skill test after written examination",
    category: "SSC",
    intro:
      "Bihar Public Service Commission clerk and assistant recruitments commonly include a Hindi typing skill test on computer. Practice daily on Typogram with exam-pattern passages and timed mocks.",
    faqs: [
      { q: "Is typing test mandatory in BPSC clerk exam?", a: "When listed in the official BPSC notification for your post, the typing skill test is qualifying. Read the advertisement carefully." },
      { q: "Which Hindi font is used in BPSC typing test?", a: "Bihar exams often use Kruti Dev or Unicode Hindi layouts. Match your practice keyboard to the notification." },
      { q: "How to prepare for BPSC typing test online?", a: "Use Typogram's free Hindi typing test daily and aim for consistent accuracy above 95% before increasing speed." },
    ],
  },
  "mppsc-typing-test": {
    slug: "mppsc-typing-test",
    title: "MPPSC Typing Test — Madhya Pradesh PSC Skill Test | Typogram",
    metaDescription:
      "MPPSC typing test guide for Madhya Pradesh PSC clerk, assistant, and data entry posts. Hindi and English WPM preparation with free mocks on Typogram.",
    keywords: "MPPSC typing test, MP PSC typing test, Madhya Pradesh typing test, MP clerk skill test, MPPSC Hindi typing",
    h1: "MPPSC Typing Test Preparation",
    exam: "MPPSC (Madhya Pradesh PSC)",
    wpm: "Notification-specific; often 30 WPM Hindi or English",
    stage: "Skill test when notified for the post",
    category: "SSC",
    intro:
      "MPPSC state service and clerk recruitments may require a computer-based typing skill test in Hindi or English. Typogram offers free timed practice aligned with government exam patterns.",
    faqs: [
      { q: "Which MPPSC posts have typing tests?", a: "Clerk, assistant, and similar ministerial posts when specified in the MPPSC official notification — not all MPPSC posts require typing." },
      { q: "What speed is required for MPPSC typing?", a: "Varies by post and cycle. Use 30 WPM as a planning target and confirm in the MPPSC advertisement." },
      { q: "Can I practice MPPSC typing test for free?", a: "Yes — start at typogram.in/typing-display and use Hindi or English timed tests daily." },
    ],
  },
  "rpsc-typing-test": {
    slug: "rpsc-typing-test",
    title: "RPSC Typing Test — Rajasthan PSC Clerk Skill Test | Typogram",
    metaDescription:
      "RPSC typing test preparation for Rajasthan PSC clerk, LDC, and assistant posts. Hindi typing WPM targets, exam tips, and free practice on Typogram.",
    keywords: "RPSC typing test, Rajasthan PSC typing test, Rajasthan clerk typing test, RPSC skill test, RPSC Hindi typing",
    h1: "RPSC Typing Test Preparation",
    exam: "RPSC (Rajasthan PSC)",
    wpm: "Often 25–35 WPM Hindi for clerk/LDC posts",
    stage: "Skill test after qualifying written exam",
    category: "SSC",
    intro:
      "Rajasthan Public Service Commission recruitments for clerk, LDC, and assistant categories frequently include a qualifying Hindi typing test. Build speed and accuracy with Typogram's free online typing practice.",
    faqs: [
      { q: "Does RPSC conduct a typing test?", a: "Many RPSC clerk and LDC notifications include a typing skill test. Verify your post's official RPSC advertisement." },
      { q: "What is the RPSC typing test format?", a: "Typically a timed passage on computer with error penalties per official rules. Practice under timed conditions on Typogram." },
      { q: "How to improve Hindi typing for RPSC?", a: "Practice 45–60 minutes daily in Kruti Dev or Mangal layout, focus on accuracy first, then increase WPM weekly." },
    ],
  },
  "ukpsc-typing-test": {
    slug: "ukpsc-typing-test",
    title: "UKPSC Typing Test — Uttarakhand PSC Clerk Skill Test | Typogram",
    metaDescription:
      "UKPSC typing test preparation for Uttarakhand PSC clerk, assistant, and review officer posts. Hindi and English WPM practice on Typogram.",
    keywords: "UKPSC typing test, Uttarakhand PSC typing test, UK clerk typing test, Uttarakhand Hindi typing",
    h1: "UKPSC Typing Test Preparation",
    exam: "UKPSC (Uttarakhand PSC)",
    wpm: "Often 25–30 WPM Hindi or English (verify notice)",
    stage: "Skill test when listed in notification",
    category: "SSC",
    intro:
      "Uttarakhand Public Service Commission clerk and assistant recruitments may include a computer typing skill test in Hindi or English. Typogram offers free timed practice for UKPSC aspirants.",
    faqs: [
      { q: "Does UKPSC have a typing test?", a: "When the official UKPSC notification lists a skill test for your post, typing is qualifying. Always read the latest advertisement." },
      { q: "Hindi or English for UKPSC typing?", a: "Uttarakhand posts often require Hindi typing. Confirm language and font layout in your notification." },
      { q: "How to prepare for UKPSC typing online?", a: "Practice daily on typogram.in/typing-display with timed mocks and aim for 95%+ accuracy before pushing speed." },
    ],
  },
  "hpsc-typing-test": {
    slug: "hpsc-typing-test",
    title: "HPSC Typing Test — Haryana PSC Clerk Skill Test | Typogram",
    metaDescription:
      "HPSC typing test guide for Haryana PSC clerk, assistant, and LDC posts. Hindi typing WPM targets and free online practice on Typogram.",
    keywords: "HPSC typing test, Haryana PSC typing test, Haryana clerk typing test, HPSC skill test, Haryana Hindi typing",
    h1: "HPSC Typing Test Preparation",
    exam: "HPSC (Haryana PSC)",
    wpm: "Typically 25–35 WPM Hindi for clerk posts",
    stage: "Skill test after written examination",
    category: "SSC",
    intro:
      "Haryana Public Service Commission recruitments for clerk and assistant categories often include a Hindi typing skill test on computer. Build exam-ready speed with Typogram's free practice platform.",
    faqs: [
      { q: "Is typing test part of HPSC clerk recruitment?", a: "When specified in the HPSC notification for your post, the typing test is usually qualifying. Check the official notice." },
      { q: "Which font is used in Haryana typing tests?", a: "Hindi exams commonly use Kruti Dev or Unicode layouts. Match your practice keyboard to the notification." },
      { q: "What WPM target for HPSC typing test?", a: "Prepare for 25–35 WPM in Hindi as a baseline and verify the current HPSC advertisement." },
    ],
  },
  "gpsc-typing-test": {
    slug: "gpsc-typing-test",
    title: "GPSC Typing Test — Gujarat PSC Clerk Skill Test | Typogram",
    metaDescription:
      "GPSC typing test preparation for Gujarat PSC clerk, assistant, and data entry posts. Gujarati and English typing practice with free mocks on Typogram.",
    keywords: "GPSC typing test, Gujarat PSC typing test, Gujarat clerk typing test, GPSC skill test, Gujarati typing test",
    h1: "GPSC Typing Test Preparation",
    exam: "GPSC (Gujarat PSC)",
    wpm: "Notification-specific; often 30 WPM in required language",
    stage: "Skill test after qualifying exam",
    category: "SSC",
    intro:
      "Gujarat Public Service Commission clerk and assistant notifications may require a typing skill test in Gujarati, Hindi, or English depending on the post. Practice timed tests daily on Typogram.",
    faqs: [
      { q: "Which GPSC posts require typing tests?", a: "Ministerial and clerk posts when listed in the official GPSC advertisement — not every GPSC post includes typing." },
      { q: "Is Gujarati typing required for GPSC?", a: "Some Gujarat posts require Gujarati typing; others accept English or Hindi. Read your specific notification." },
      { q: "How to practice GPSC typing test free?", a: "Use Typogram's free typing test for English and Hindi daily, and verify Gujarati layout requirements from your notice." },
    ],
  },
  "kpsc-typing-test": {
    slug: "kpsc-typing-test",
    title: "KPSC Typing Test — Karnataka PSC Clerk Skill Test | Typogram",
    metaDescription:
      "KPSC typing test guide for Karnataka PSC clerk, assistant, and FDA/SDA posts. English and Kannada typing WPM preparation on Typogram.",
    keywords: "KPSC typing test, Karnataka PSC typing test, KPSC clerk typing, Karnataka typing skill test, KPSC English typing",
    h1: "KPSC Typing Test Preparation",
    exam: "KPSC (Karnataka PSC)",
    wpm: "Often 30 WPM English; Kannada where notified",
    stage: "Skill test when applicable to the post",
    category: "SSC",
    intro:
      "Karnataka Public Service Commission recruitments for clerk, assistant, and similar posts may include English or Kannada typing skill tests. Typogram helps KPSC aspirants build speed with structured daily practice.",
    faqs: [
      { q: "Does KPSC conduct a typing test?", a: "Many KPSC FDA/SDA and clerk notifications include a computer typing skill test. Confirm in your official KPSC advertisement." },
      { q: "English or Kannada typing for KPSC?", a: "Depends on the post — many Karnataka clerk posts use English typing; some require Kannada. Check your notification." },
      { q: "How to prepare for KPSC typing test?", a: "Practice 45–60 minutes daily on Typogram with timed mocks under exam conditions and track WPM weekly." },
    ],
  },
  "tnpsc-typing-test": {
    slug: "tnpsc-typing-test",
    title: "TNPSC Typing Test — Tamil Nadu PSC Clerk Skill Test | Typogram",
    metaDescription:
      "TNPSC typing test preparation for Tamil Nadu PSC clerk, assistant, and typist posts. Tamil and English WPM targets with free practice on Typogram.",
    keywords: "TNPSC typing test, Tamil Nadu PSC typing test, TN clerk typing test, TNPSC skill test, Tamil typing test",
    h1: "TNPSC Typing Test Preparation",
    exam: "TNPSC (Tamil Nadu PSC)",
    wpm: "Often 30 WPM in Tamil or English (verify notification)",
    stage: "Skill test when listed for the post",
    category: "SSC",
    intro:
      "Tamil Nadu Public Service Commission recruitments for clerk, assistant, and typist categories may include Tamil or English typing skill tests. Practice daily on Typogram with timed exam-pattern mocks.",
    faqs: [
      { q: "Does TNPSC have a typing test?", a: "Many TNPSC ministerial notifications include a computer typing skill test. Check your post's official TNPSC advertisement." },
      { q: "Tamil or English typing for TNPSC?", a: "Tamil Nadu posts often require Tamil typing; some accept English. Confirm language requirements in the notification." },
      { q: "How to prepare for TNPSC typing test online?", a: "Use Typogram's free English typing test daily and verify Tamil layout requirements from your official notice." },
    ],
  },
  "appsc-typing-test": {
    slug: "appsc-typing-test",
    title: "APPSC Typing Test — Andhra Pradesh PSC Skill Test | Typogram",
    metaDescription:
      "APPSC typing test guide for Andhra Pradesh PSC clerk, assistant, and department posts. Telugu and English WPM preparation on Typogram.",
    keywords: "APPSC typing test, Andhra Pradesh PSC typing test, AP clerk typing test, APPSC skill test, Telugu typing test",
    h1: "APPSC Typing Test Preparation",
    exam: "APPSC (Andhra Pradesh PSC)",
    wpm: "Notification-specific; often 30 WPM",
    stage: "Skill test after qualifying written exam",
    category: "SSC",
    intro:
      "Andhra Pradesh Public Service Commission clerk and assistant recruitments may require Telugu or English typing skill tests on computer. Build speed and accuracy with Typogram's free practice platform.",
    faqs: [
      { q: "Which APPSC posts have typing tests?", a: "Clerk, assistant, and typist posts when specified in the APPSC official notification — not all APPSC posts require typing." },
      { q: "Telugu or English for APPSC typing?", a: "Depends on the post and notification year. Read the official APPSC advertisement for language and WPM targets." },
      { q: "Free APPSC typing test practice?", a: "Yes — start at typogram.in/typing-display for English timed tests and build accuracy before increasing speed." },
    ],
  },
  "wbpsc-typing-test": {
    slug: "wbpsc-typing-test",
    title: "WBPSC Typing Test — West Bengal PSC Clerk Skill Test | Typogram",
    metaDescription:
      "WBPSC typing test preparation for West Bengal PSC clerk, LDC, and assistant posts. Bengali and English typing WPM guide on Typogram.",
    keywords: "WBPSC typing test, West Bengal PSC typing test, WB clerk typing test, WBPSC skill test, Bengali typing test",
    h1: "WBPSC Typing Test Preparation",
    exam: "WBPSC (West Bengal PSC)",
    wpm: "Often 25–35 WPM in Bengali or English",
    stage: "Skill test when notified",
    category: "SSC",
    intro:
      "West Bengal Public Service Commission recruitments for clerk, LDC, and assistant posts may include Bengali or English typing skill tests. Typogram helps WBPSC aspirants with structured English and Hindi typing practice.",
    faqs: [
      { q: "Is typing test mandatory in WBPSC clerk exam?", a: "When the WBPSC notification lists a skill test for your post, typing is qualifying. Always verify the latest advertisement." },
      { q: "Bengali typing required for WBPSC?", a: "Many West Bengal posts require Bengali typing; some accept English. Confirm in your official WBPSC notice." },
      { q: "How to improve typing speed for WBPSC?", a: "Practice 45–60 minutes daily on Typogram with timed mocks, prioritizing accuracy above 95% before increasing WPM." },
    ],
  },
  "opsc-typing-test": {
    slug: "opsc-typing-test",
    title: "OPSC Typing Test — Odisha PSC Clerk Skill Test | Typogram",
    metaDescription:
      "OPSC typing test guide for Odisha PSC clerk, assistant, and data entry posts. Odia and English WPM targets with free online practice on Typogram.",
    keywords: "OPSC typing test, Odisha PSC typing test, Odisha clerk typing test, OPSC skill test, Odia typing test",
    h1: "OPSC Typing Test Preparation",
    exam: "OPSC (Odisha PSC)",
    wpm: "Often 30 WPM English; Odia where notified",
    stage: "Skill test after written examination",
    category: "SSC",
    intro:
      "Odisha Public Service Commission recruitments for clerk and assistant categories may include Odia or English typing skill tests. Prepare with free timed typing practice on Typogram.",
    faqs: [
      { q: "Does OPSC conduct a typing test?", a: "Many OPSC clerk and assistant notifications include a computer typing skill test. Verify your specific post's official advertisement." },
      { q: "Odia or English typing for OPSC?", a: "Depends on the post — confirm language and font requirements in the OPSC notification." },
      { q: "How to prepare for OPSC typing test?", a: "Use Typogram's free typing test daily with exam-pattern timed passages and weekly full-length mock skill tests." },
    ],
  },
  "stenography-test": {
    slug: "stenography-test",
    title: "Stenography Test Online — SSC & Court Steno Skill Test Guide | Typogram",
    metaDescription:
      "Stenography test preparation for SSC steno, court stenographer, and skill test aspirants. Shorthand speed targets, dictation practice, and typing integration on Typogram.",
    keywords: "stenography test, steno skill test, SSC stenographer test, court steno test, shorthand dictation test, stenography exam",
    h1: "Stenography Test Preparation",
    exam: "SSC Steno / Court Stenographer",
    wpm: "80–100 WPM shorthand typical for SSC steno (verify notice)",
    stage: "Skill test / dictation after written exam",
    category: "Steno",
    intro:
      "Stenography skill tests for SSC stenographer, court steno, and allied posts combine shorthand dictation with computer typing. Typogram's steno module helps you practice dictation passages and build exam-ready speed.",
    faqs: [
      { q: "What is the stenography test in SSC?", a: "SSC stenographer skill test includes shorthand dictation at a specified speed followed by transcription on computer. Check the official SSC notice for WPM targets." },
      { q: "How is stenography different from typing test?", a: "Stenography uses shorthand symbols to capture speech at high speed, then transcribes to text. Typing tests measure direct keyboard WPM on given passages." },
      { q: "Where to practice stenography online?", a: "Use Typogram's steno practice at typogram.in/steno with dictation passages and timed skill test simulations." },
    ],
  },
  "steno-practice": {
    slug: "steno-practice",
    title: "Steno Practice Online — Free Shorthand Dictation Drills | Typogram",
    metaDescription:
      "Free steno practice online for SSC stenographer and court steno aspirants. Shorthand dictation drills, speed building, and skill test prep on Typogram.",
    keywords: "steno practice, stenography practice online, shorthand practice, SSC steno practice, dictation practice, steno speed building",
    h1: "Steno Practice Online",
    exam: "Stenography / Shorthand",
    wpm: "Build from 60 WPM upward toward exam targets",
    stage: "Daily dictation and transcription drills",
    category: "Steno",
    intro:
      "Daily steno practice is essential for SSC stenographer and court steno exams. Typogram offers structured dictation passages, speed tracking, and integration with typing skill tests.",
    faqs: [
      { q: "How to start steno practice as a beginner?", a: "Learn shorthand outlines, then practice 30–45 minutes daily with slow dictation before increasing speed on Typogram's steno module." },
      { q: "Is Typogram steno practice free?", a: "Core steno practice features are available on typogram.in/steno. Check pricing for advanced packs at typogram.in/steno/pricing." },
      { q: "How much daily steno practice is needed?", a: "Most successful candidates practice 1–2 hours daily — dictation, transcription, and typing warm-ups combined." },
    ],
  },
  "ppsc-typing-test": {
    slug: "ppsc-typing-test",
    title: "PPSC Typing Test — Punjab PSC Clerk Skill Test | Typogram",
    metaDescription:
      "PPSC typing test preparation for Punjab PSC clerk, assistant, and typist posts. Punjabi and English WPM practice with free mocks on Typogram.",
    keywords: "PPSC typing test, Punjab PSC typing test, Punjab clerk typing test, PPSC skill test, Punjabi typing test",
    h1: "PPSC Typing Test Preparation",
    exam: "PPSC (Punjab PSC)",
    wpm: "Often 25–35 WPM in Punjabi or English (verify notice)",
    stage: "Skill test when listed in notification",
    category: "SSC",
    intro:
      "Punjab Public Service Commission clerk and assistant recruitments may include Punjabi or English typing skill tests on computer. Typogram helps PPSC aspirants build speed with daily timed practice.",
    faqs: [
      { q: "Does PPSC conduct a typing test?", a: "Many PPSC clerk and typist notifications include a qualifying typing skill test. Check your post's official PPSC advertisement." },
      { q: "Punjabi or English typing for PPSC?", a: "Punjab posts often require Punjabi typing; some accept English. Confirm language requirements in the notification." },
      { q: "How to prepare for PPSC typing test online?", a: "Practice daily on typogram.in/typing-display with timed mocks and focus on 95%+ accuracy before increasing WPM." },
    ],
  },
  "mpsc-typing-test": {
    slug: "mpsc-typing-test",
    title: "MPSC Typing Test — Maharashtra PSC Clerk Skill Test | Typogram",
    metaDescription:
      "MPSC typing test guide for Maharashtra PSC clerk, assistant, and ASO posts. Marathi and English WPM targets with free practice on Typogram.",
    keywords: "MPSC typing test, Maharashtra PSC typing test, MPSC clerk typing, Maharashtra typing skill test, Marathi typing test",
    h1: "MPSC Typing Test Preparation",
    exam: "MPSC (Maharashtra PSC)",
    wpm: "Often 30 WPM in Marathi or English (verify notice)",
    stage: "Skill test after qualifying examination",
    category: "SSC",
    intro:
      "Maharashtra Public Service Commission recruitments for clerk, assistant, and similar posts may require Marathi or English typing skill tests. Build exam-ready speed with Typogram's free typing practice.",
    faqs: [
      { q: "Which MPSC posts require typing tests?", a: "Clerk, assistant, and typist posts when specified in the MPSC official notification — not every MPSC post includes typing." },
      { q: "Marathi or English for MPSC typing?", a: "Many Maharashtra posts require Marathi typing; others accept English. Read your specific MPSC advertisement." },
      { q: "Free MPSC typing test practice?", a: "Yes — use Typogram's free typing test at typogram.in/typing-display with daily timed exam-pattern passages." },
    ],
  },
  "cgpsc-typing-test": {
    slug: "cgpsc-typing-test",
    title: "CGPSC Typing Test — Chhattisgarh PSC Skill Test | Typogram",
    metaDescription:
      "CGPSC typing test preparation for Chhattisgarh PSC clerk, assistant, and data entry posts. Hindi and English WPM guide on Typogram.",
    keywords: "CGPSC typing test, Chhattisgarh PSC typing test, CG clerk typing test, CGPSC skill test, Chhattisgarh Hindi typing",
    h1: "CGPSC Typing Test Preparation",
    exam: "CGPSC (Chhattisgarh PSC)",
    wpm: "Typically 25–30 WPM Hindi for clerk posts",
    stage: "Skill test when applicable",
    category: "SSC",
    intro:
      "Chhattisgarh Public Service Commission clerk and assistant notifications may include Hindi or English typing skill tests. Practice daily on Typogram with structured timed mocks.",
    faqs: [
      { q: "Is typing test part of CGPSC recruitment?", a: "When listed in the CGPSC notification for your post, the typing skill test is usually qualifying. Verify the official notice." },
      { q: "Hindi typing for CGPSC?", a: "Chhattisgarh exams commonly require Hindi typing in Kruti Dev or Unicode layout. Match your practice to the notification." },
      { q: "How to improve typing for CGPSC?", a: "Practice 45–60 minutes daily on Typogram, prioritize accuracy, and take weekly full-length mock skill tests." },
    ],
  },
  "jpsc-typing-test": {
    slug: "jpsc-typing-test",
    title: "JPSC Typing Test — Jharkhand PSC Clerk Skill Test | Typogram",
    metaDescription:
      "JPSC typing test preparation for Jharkhand PSC clerk, assistant, and LDC posts. Hindi and English WPM targets with free online practice on Typogram.",
    keywords: "JPSC typing test, Jharkhand PSC typing test, Jharkhand clerk typing test, JPSC skill test, JPSC Hindi typing",
    h1: "JPSC Typing Test Preparation",
    exam: "JPSC (Jharkhand PSC)",
    wpm: "Often 25–35 WPM Hindi or English",
    stage: "Skill test after written exam",
    category: "SSC",
    intro:
      "Jharkhand Public Service Commission recruitments for clerk, LDC, and assistant categories may include qualifying Hindi or English typing tests. Typogram offers free timed practice for JPSC aspirants.",
    faqs: [
      { q: "Does JPSC have a typing test?", a: "Many JPSC clerk and assistant notifications include a computer typing skill test. Confirm in your official JPSC advertisement." },
      { q: "What WPM is needed for JPSC typing?", a: "Targets vary by post and year. Prepare for 25–35 WPM in your required language and verify the latest JPSC notice." },
      { q: "Where to practice JPSC typing test free?", a: "Start at typogram.in/typing-display and practice Hindi or English timed tests daily on Typogram." },
    ],
  },
  "apsc-typing-test": {
    slug: "apsc-typing-test",
    title: "APSC Typing Test — Assam PSC Clerk Skill Test | Typogram",
    metaDescription:
      "APSC typing test preparation for Assam PSC clerk, assistant, and typist posts. Assamese and English WPM practice on Typogram.",
    keywords: "APSC typing test, Assam PSC typing test, Assam clerk typing test, APSC skill test, Assamese typing test",
    h1: "APSC Typing Test Preparation",
    exam: "APSC (Assam PSC)",
    wpm: "Often 30 WPM in Assamese or English (verify notice)",
    stage: "Skill test when listed for the post",
    category: "SSC",
    intro:
      "Assam Public Service Commission recruitments for clerk, assistant, and typist posts may include Assamese or English typing skill tests. Practice daily on Typogram with timed exam-pattern mocks.",
    faqs: [
      { q: "Does APSC conduct a typing test?", a: "Many APSC ministerial notifications include a computer typing skill test. Check your post's official APSC advertisement." },
      { q: "Assamese or English typing for APSC?", a: "Assam posts often require Assamese typing; some accept English. Confirm language requirements in the notification." },
      { q: "How to prepare for APSC typing online?", a: "Use Typogram's free English typing test daily and verify Assamese layout requirements from your official notice." },
    ],
  },
  "kerala-psc-typing-test": {
    slug: "kerala-psc-typing-test",
    title: "Kerala PSC Typing Test — Clerk & Assistant Skill Test | Typogram",
    metaDescription:
      "Kerala PSC typing test guide for clerk, assistant, and LDC posts. Malayalam and English WPM targets with free practice on Typogram.",
    keywords: "Kerala PSC typing test, KPSC typing test Kerala, Kerala clerk typing test, Kerala PSC skill test, Malayalam typing test",
    h1: "Kerala PSC Typing Test Preparation",
    exam: "Kerala PSC",
    wpm: "Often 30 WPM in Malayalam or English",
    stage: "Skill test after qualifying exam",
    category: "SSC",
    intro:
      "Kerala Public Service Commission recruitments for clerk, assistant, and LDC categories may include Malayalam or English typing skill tests on computer. Build speed with Typogram's free practice platform.",
    faqs: [
      { q: "Which Kerala PSC posts have typing tests?", a: "Clerk, assistant, and typist posts when specified in the Kerala PSC official notification." },
      { q: "Malayalam or English for Kerala PSC typing?", a: "Many Kerala posts require Malayalam typing; others accept English. Read your specific advertisement." },
      { q: "Free Kerala PSC typing test practice?", a: "Yes — practice at typogram.in/typing-display with daily timed tests and track your WPM progress." },
    ],
  },
  "tspsc-typing-test": {
    slug: "tspsc-typing-test",
    title: "TSPSC Typing Test — Telangana PSC Clerk Skill Test | Typogram",
    metaDescription:
      "TSPSC typing test preparation for Telangana PSC clerk, assistant, and typist posts. Telugu and English WPM guide on Typogram.",
    keywords: "TSPSC typing test, Telangana PSC typing test, TS clerk typing test, TSPSC skill test, Telugu typing test",
    h1: "TSPSC Typing Test Preparation",
    exam: "TSPSC (Telangana PSC)",
    wpm: "Notification-specific; often 30 WPM",
    stage: "Skill test when applicable",
    category: "SSC",
    intro:
      "Telangana State Public Service Commission clerk and assistant recruitments may require Telugu or English typing skill tests. Typogram helps TSPSC aspirants with structured English and Hindi typing practice.",
    faqs: [
      { q: "Is typing test part of TSPSC recruitment?", a: "When the TSPSC notification lists a skill test for your post, typing is qualifying. Always verify the latest advertisement." },
      { q: "Telugu or English for TSPSC typing?", a: "Depends on the post — confirm language and font requirements in the TSPSC notification." },
      { q: "How to prepare for TSPSC typing test?", a: "Practice 45–60 minutes daily on Typogram with timed mocks and aim for 95%+ accuracy before increasing speed." },
    ],
  },
  "hppsc-typing-test": {
    slug: "hppsc-typing-test",
    title: "HPPSC Typing Test — Himachal Pradesh PSC Skill Test | Typogram",
    metaDescription:
      "HPPSC typing test guide for Himachal Pradesh PSC clerk, assistant, and LDC posts. Hindi and English WPM preparation on Typogram.",
    keywords: "HPPSC typing test, Himachal PSC typing test, HP clerk typing test, HPPSC skill test, Himachal Hindi typing",
    h1: "HPPSC Typing Test Preparation",
    exam: "HPPSC (Himachal Pradesh PSC)",
    wpm: "Often 25–30 WPM Hindi or English",
    stage: "Skill test after written examination",
    category: "SSC",
    intro:
      "Himachal Pradesh Public Service Commission recruitments for clerk and assistant posts may include Hindi or English typing skill tests. Prepare with free timed typing practice on Typogram.",
    faqs: [
      { q: "Does HPPSC have a typing test?", a: "Many HPPSC clerk and assistant notifications include a computer typing skill test. Confirm in your official HPPSC advertisement." },
      { q: "Hindi typing for HPPSC?", a: "Himachal posts commonly require Hindi typing in Kruti Dev or Unicode layout. Match your practice keyboard to the notification." },
      { q: "Where to practice HPPSC typing free?", a: "Start at typogram.in/typing-display and use Hindi or English timed tests daily on Typogram." },
    ],
  },
  "arunachal-psc-typing-test": {
    slug: "arunachal-psc-typing-test",
    title: "Arunachal PSC Typing Test — APPSC Clerk Skill Test | Typogram",
    metaDescription: "Arunachal Pradesh PSC typing test guide for clerk, assistant, and LDC posts. English typing WPM practice on Typogram.",
    keywords: "Arunachal PSC typing test, APPSC typing test, Arunachal clerk typing test, Arunachal skill test",
    h1: "Arunachal Pradesh PSC Typing Test Preparation",
    exam: "Arunachal Pradesh PSC",
    wpm: "Often 30 WPM English (verify notice)",
    stage: "Skill test when listed for the post",
    category: "SSC",
    intro: "Arunachal Pradesh Public Service Commission recruitments for clerk and assistant posts may include English typing skill tests. Practice daily with free timed tests on Typogram.",
    faqs: [
      { q: "Does Arunachal PSC have a typing test?", a: "When the APPSC notification lists a computer skill test for your post, typing may be qualifying. Check your official advertisement." },
      { q: "Which language for Arunachal PSC typing?", a: "Most Arunachal ministerial posts require English typing. Confirm language requirements in the notification." },
      { q: "Free Arunachal PSC typing practice online?", a: "Yes — use typogram.in/typing-display for daily English timed typing tests." },
    ],
  },
  "goa-psc-typing-test": {
    slug: "goa-psc-typing-test",
    title: "Goa PSC Typing Test — Clerk & Assistant Skill Test | Typogram",
    metaDescription: "Goa PSC typing test preparation for clerk, assistant, and LDC posts. English and Konkani typing practice on Typogram.",
    keywords: "Goa PSC typing test, Goa clerk typing test, Goa PSC skill test, Goa typing test online",
    h1: "Goa PSC Typing Test Preparation",
    exam: "Goa PSC",
    wpm: "Often 30 WPM English (verify notice)",
    stage: "Skill test after qualifying exam",
    category: "SSC",
    intro: "Goa Public Service Commission recruitments for clerk and assistant categories may include English typing skill tests on computer. Build speed with Typogram's free practice platform.",
    faqs: [
      { q: "Which Goa PSC posts have typing tests?", a: "Clerk, assistant, and typist posts when specified in the Goa PSC official notification." },
      { q: "English or Konkani for Goa PSC typing?", a: "Many Goa posts require English typing. Read your specific advertisement for language rules." },
      { q: "How to prepare for Goa PSC typing test?", a: "Practice 45–60 minutes daily on Typogram with timed mocks and aim for 95%+ accuracy." },
    ],
  },
  "manipur-psc-typing-test": {
    slug: "manipur-psc-typing-test",
    title: "Manipur PSC Typing Test — Clerk Skill Test | Typogram",
    metaDescription: "Manipur PSC typing test guide for clerk, assistant, and LDC posts. English and Manipuri typing WPM targets on Typogram.",
    keywords: "Manipur PSC typing test, MPSC Manipur typing test, Manipur clerk typing test, Manipur skill test",
    h1: "Manipur PSC Typing Test Preparation",
    exam: "Manipur PSC",
    wpm: "Often 30 WPM (verify notification)",
    stage: "Skill test when applicable",
    category: "SSC",
    intro: "Manipur Public Service Commission clerk and assistant recruitments may require English or regional language typing skill tests. Typogram helps aspirants with structured English typing practice.",
    faqs: [
      { q: "Is typing test part of Manipur PSC recruitment?", a: "When the Manipur PSC notification lists a skill test for your post, typing is qualifying. Verify the latest advertisement." },
      { q: "What WPM is needed for Manipur PSC typing?", a: "Targets vary by post. Prepare for 25–35 WPM and confirm in your official notice." },
      { q: "Free Manipur PSC typing test practice?", a: "Practice at typogram.in/typing-display with daily timed English typing tests on Typogram." },
    ],
  },
  "meghalaya-psc-typing-test": {
    slug: "meghalaya-psc-typing-test",
    title: "Meghalaya PSC Typing Test — MPSC Clerk Skill Test | Typogram",
    metaDescription: "Meghalaya PSC typing test preparation for clerk, assistant, and typist posts. English typing WPM guide on Typogram.",
    keywords: "Meghalaya PSC typing test, MPSC Meghalaya typing test, Meghalaya clerk typing test, Meghalaya skill test",
    h1: "Meghalaya PSC Typing Test Preparation",
    exam: "Meghalaya PSC (MPSC)",
    wpm: "Often 30 WPM English",
    stage: "Skill test after written exam",
    category: "SSC",
    intro: "Meghalaya Public Service Commission recruitments for clerk and assistant posts may include English typing skill tests. Prepare with free timed typing practice on Typogram.",
    faqs: [
      { q: "Does Meghalaya PSC conduct a typing test?", a: "Many Meghalaya PSC ministerial notifications include a computer typing skill test. Confirm in your official advertisement." },
      { q: "English typing for Meghalaya PSC?", a: "Meghalaya posts commonly require English typing. Match your practice keyboard to the notification." },
      { q: "Where to practice Meghalaya PSC typing free?", a: "Start at typogram.in/typing-display and use English timed tests daily on Typogram." },
    ],
  },
  "mizoram-psc-typing-test": {
    slug: "mizoram-psc-typing-test",
    title: "Mizoram PSC Typing Test — Clerk Skill Test | Typogram",
    metaDescription: "Mizoram PSC typing test guide for clerk, assistant, and LDC posts. English typing WPM preparation on Typogram.",
    keywords: "Mizoram PSC typing test, Mizoram clerk typing test, Mizoram PSC skill test, Mizoram typing test online",
    h1: "Mizoram PSC Typing Test Preparation",
    exam: "Mizoram PSC",
    wpm: "Often 30 WPM English",
    stage: "Skill test when listed",
    category: "SSC",
    intro: "Mizoram Public Service Commission recruitments for clerk and assistant categories may include qualifying English typing tests. Typogram offers free timed practice for Mizoram PSC aspirants.",
    faqs: [
      { q: "Does Mizoram PSC have a typing test?", a: "Many Mizoram PSC clerk notifications include a computer typing skill test. Confirm in your official advertisement." },
      { q: "What WPM for Mizoram PSC typing?", a: "Prepare for 25–35 WPM in English and verify the latest Mizoram PSC notice." },
      { q: "Free Mizoram PSC typing practice?", a: "Use typogram.in/typing-display for daily timed English typing tests." },
    ],
  },
  "nagaland-psc-typing-test": {
    slug: "nagaland-psc-typing-test",
    title: "Nagaland PSC Typing Test — NPSC Clerk Skill Test | Typogram",
    metaDescription: "Nagaland PSC typing test preparation for clerk, assistant, and LDC posts. English typing WPM targets on Typogram.",
    keywords: "Nagaland PSC typing test, NPSC typing test, Nagaland clerk typing test, Nagaland skill test",
    h1: "Nagaland PSC Typing Test Preparation",
    exam: "Nagaland PSC (NPSC)",
    wpm: "Often 30 WPM English",
    stage: "Skill test after qualifying exam",
    category: "SSC",
    intro: "Nagaland Public Service Commission recruitments for clerk and assistant posts may include English typing skill tests. Build speed with Typogram's free online practice.",
    faqs: [
      { q: "Which Nagaland PSC posts have typing tests?", a: "Clerk, assistant, and typist posts when specified in the NPSC official notification." },
      { q: "English typing for Nagaland PSC?", a: "Nagaland ministerial posts typically require English typing. Confirm in your advertisement." },
      { q: "How to prepare for Nagaland PSC typing?", a: "Practice daily on Typogram with timed mocks and track WPM progress." },
    ],
  },
  "sikkim-psc-typing-test": {
    slug: "sikkim-psc-typing-test",
    title: "Sikkim PSC Typing Test — Clerk Skill Test | Typogram",
    metaDescription: "Sikkim PSC typing test guide for clerk, assistant, and LDC posts. English and Nepali typing practice on Typogram.",
    keywords: "Sikkim PSC typing test, Sikkim clerk typing test, Sikkim PSC skill test, Sikkim typing test online",
    h1: "Sikkim PSC Typing Test Preparation",
    exam: "Sikkim PSC",
    wpm: "Often 30 WPM English",
    stage: "Skill test when applicable",
    category: "SSC",
    intro: "Sikkim Public Service Commission recruitments for clerk and assistant posts may include English typing skill tests on computer. Prepare with free timed practice on Typogram.",
    faqs: [
      { q: "Does Sikkim PSC have a typing test?", a: "When the Sikkim PSC notification lists a skill test for your post, typing may be qualifying. Check the official notice." },
      { q: "What language for Sikkim PSC typing?", a: "English typing is common for Sikkim PSC ministerial posts. Verify in your advertisement." },
      { q: "Free Sikkim PSC typing test practice?", a: "Start at typogram.in/typing-display with daily English timed tests on Typogram." },
    ],
  },
  "tripura-psc-typing-test": {
    slug: "tripura-psc-typing-test",
    title: "Tripura PSC Typing Test — TPSC Clerk Skill Test | Typogram",
    metaDescription: "Tripura PSC typing test preparation for clerk, assistant, and typist posts. Bengali and English WPM guide on Typogram.",
    keywords: "Tripura PSC typing test, TPSC typing test, Tripura clerk typing test, Tripura skill test",
    h1: "Tripura PSC Typing Test Preparation",
    exam: "Tripura PSC (TPSC)",
    wpm: "Often 30 WPM Bengali or English",
    stage: "Skill test after written examination",
    category: "SSC",
    intro: "Tripura Public Service Commission clerk and assistant recruitments may require Bengali or English typing skill tests. Typogram helps TPSC aspirants with English and Hindi typing practice.",
    faqs: [
      { q: "Is typing test part of Tripura PSC recruitment?", a: "When the TPSC notification lists a skill test for your post, typing is qualifying. Verify the latest advertisement." },
      { q: "Bengali or English for Tripura PSC typing?", a: "Depends on the post — confirm language requirements in the TPSC notification." },
      { q: "How to prepare for Tripura PSC typing test?", a: "Practice 45–60 minutes daily on Typogram with timed mocks and aim for high accuracy." },
    ],
  },
  "jkpsc-typing-test": {
    slug: "jkpsc-typing-test",
    title: "JKPSC Typing Test — J&K PSC Clerk Skill Test | Typogram",
    metaDescription: "JKPSC typing test guide for Jammu & Kashmir PSC clerk, assistant, and LDC posts. English and Urdu typing WPM on Typogram.",
    keywords: "JKPSC typing test, Jammu Kashmir PSC typing test, JK clerk typing test, JKPSC skill test",
    h1: "JKPSC Typing Test Preparation",
    exam: "JKPSC (Jammu & Kashmir PSC)",
    wpm: "Often 30 WPM English or Urdu",
    stage: "Skill test when listed for the post",
    category: "SSC",
    intro: "Jammu & Kashmir Public Service Commission recruitments for clerk and assistant posts may include English or Urdu typing skill tests. Practice daily on Typogram.",
    faqs: [
      { q: "Does JKPSC conduct a typing test?", a: "Many JKPSC ministerial notifications include a computer typing skill test. Confirm in your official advertisement." },
      { q: "English or Urdu for JKPSC typing?", a: "JK posts may require English or Urdu typing. Match your practice to the notification." },
      { q: "Free JKPSC typing test practice online?", a: "Yes — use typogram.in/typing-display for daily timed typing tests." },
    ],
  },
  "puducherry-psc-typing-test": {
    slug: "puducherry-psc-typing-test",
    title: "Puducherry PSC Typing Test — Clerk Skill Test | Typogram",
    metaDescription: "Puducherry PSC typing test preparation for clerk, assistant, and LDC posts. Tamil and English WPM practice on Typogram.",
    keywords: "Puducherry PSC typing test, Puducherry clerk typing test, Puducherry PSC skill test, Puducherry typing test",
    h1: "Puducherry PSC Typing Test Preparation",
    exam: "Puducherry PSC",
    wpm: "Often 30 WPM Tamil or English",
    stage: "Skill test after qualifying exam",
    category: "SSC",
    intro: "Puducherry Public Service Commission recruitments for clerk and assistant categories may include Tamil or English typing skill tests. Build speed with Typogram.",
    faqs: [
      { q: "Which Puducherry PSC posts have typing tests?", a: "Clerk, assistant, and typist posts when specified in the official Puducherry PSC notification." },
      { q: "Tamil or English for Puducherry PSC typing?", a: "Many posts require Tamil or English typing. Read your specific advertisement." },
      { q: "How to prepare for Puducherry PSC typing?", a: "Practice daily on Typogram with English timed tests and verify Tamil requirements from your notice." },
    ],
  },
  "dsssb-typing-test": {
    slug: "dsssb-typing-test",
    title: "DSSSB Typing Test — Delhi Subordinate Services Skill Test | Typogram",
    metaDescription: "DSSSB typing test guide for Delhi LDC, DASS, and clerk posts. Hindi and English WPM targets with free practice on Typogram.",
    keywords: "DSSSB typing test, Delhi DSSSB typing test, Delhi LDC typing test, DSSSB skill test, Delhi clerk typing",
    h1: "DSSSB Typing Test Preparation",
    exam: "DSSSB (Delhi)",
    wpm: "Often 35 WPM Hindi or English",
    stage: "Skill test after written/Tier exam",
    category: "SSC",
    intro: "Delhi Subordinate Services Selection Board recruitments for LDC, DASS, and clerk posts commonly include Hindi or English typing skill tests. Prepare with Typogram's free timed practice.",
    faqs: [
      { q: "Does DSSSB have a typing test?", a: "Yes — most DSSSB LDC, clerk, and DASS notifications include a qualifying computer typing skill test." },
      { q: "Hindi or English for DSSSB typing?", a: "DSSSB posts often offer Hindi or English options. Confirm language and font in your official notification." },
      { q: "What WPM is needed for DSSSB typing?", a: "Typical targets are 35 WPM with high accuracy. Verify exact speed in your DSSSB advertisement." },
    ],
  },
  "chandigarh-typing-test": {
    slug: "chandigarh-typing-test",
    title: "Chandigarh Typing Test — UT Clerk Skill Test | Typogram",
    metaDescription: "Chandigarh typing test guide for UT clerk, assistant, and LDC recruitments. English and Hindi WPM practice on Typogram.",
    keywords: "Chandigarh typing test, Chandigarh clerk typing test, Chandigarh UT typing test, Chandigarh skill test",
    h1: "Chandigarh Typing Test Preparation",
    exam: "Chandigarh Administration",
    wpm: "Often 30–35 WPM Hindi or English",
    stage: "Skill test when notified",
    category: "SSC",
    intro: "Chandigarh UT recruitments for clerk and assistant posts may include Hindi or English typing skill tests. Practice daily with free timed tests on Typogram.",
    faqs: [
      { q: "Does Chandigarh recruitment include typing test?", a: "Many Chandigarh UT clerk and assistant notifications include a computer typing skill test. Check your official notice." },
      { q: "Hindi or English for Chandigarh typing?", a: "Both languages may be offered depending on the post. Confirm in your advertisement." },
      { q: "Free Chandigarh typing test practice?", a: "Use typogram.in/typing-display for daily Hindi and English timed typing tests." },
    ],
  },
  "cpct-typing-test": {
    slug: "cpct-typing-test",
    title: "CPCT Typing Test — Madhya Pradesh Computer Proficiency | Typogram",
    metaDescription: "CPCT typing test preparation for Madhya Pradesh government jobs. Hindi and English WPM, Mangal font, and free practice on Typogram.",
    keywords: "CPCT typing test, CPCT Hindi typing, MP CPCT typing test, computer proficiency certification, Mangal typing CPCT",
    h1: "CPCT Typing Test Preparation",
    exam: "CPCT (Madhya Pradesh)",
    wpm: "30 WPM Hindi and English (CPCT standard)",
    stage: "Certification exam for MP govt jobs",
    category: "SSC",
    intro: "Computer Proficiency Certification Test (CPCT) is required for many Madhya Pradesh government posts. Typogram helps you practice Hindi Mangal and English typing for CPCT-level speed and accuracy.",
    faqs: [
      { q: "What is CPCT typing test?", a: "CPCT is Madhya Pradesh's computer proficiency exam including Hindi and English typing sections required for many state government jobs." },
      { q: "What WPM is needed for CPCT?", a: "CPCT typically requires 30 WPM in Hindi (Mangal) and English with minimum accuracy thresholds. Verify current CPCT guidelines." },
      { q: "How to prepare for CPCT typing online?", a: "Practice daily on Typogram with Hindi and English timed tests and focus on Mangal keyboard accuracy." },
    ],
  },
  "epfo-typing-test": {
    slug: "epfo-typing-test",
    title: "EPFO Typing Test — SSA & Steno Skill Test | Typogram",
    metaDescription: "EPFO typing test preparation for Social Security Assistant and steno posts. English WPM targets and free practice on Typogram.",
    keywords: "EPFO typing test, EPFO SSA typing test, EPFO skill test, EPFO steno typing, employees provident fund typing test",
    h1: "EPFO Typing Test Preparation",
    exam: "EPFO",
    wpm: "Often 35 WPM English for SSA posts",
    stage: "Skill test after online exam",
    category: "Banking",
    intro: "Employees' Provident Fund Organisation recruitments for Social Security Assistant and related posts may include English typing skill tests. Prepare with Typogram's free timed practice.",
    faqs: [
      { q: "Does EPFO SSA have a typing test?", a: "EPFO SSA and similar ministerial notifications often include a qualifying English typing skill test. Check your official EPFO advertisement." },
      { q: "What WPM for EPFO typing test?", a: "Typical targets are around 35 WPM in English with high accuracy. Verify in your EPFO notification." },
      { q: "Free EPFO typing test practice?", a: "Practice at typogram.in/typing-display with daily English timed typing tests on Typogram." },
    ],
  },
  "lic-clerk-typing-test": {
    slug: "lic-clerk-typing-test",
    title: "LIC Clerk Typing Test — AAO & Assistant Skill Test | Typogram",
    metaDescription: "LIC clerk and assistant typing test preparation. English WPM targets for LIC AAO, ADO, and clerk skill tests on Typogram.",
    keywords: "LIC typing test, LIC clerk typing test, LIC assistant skill test, LIC AAO typing test, insurance typing test",
    h1: "LIC Clerk Typing Test Preparation",
    exam: "LIC",
    wpm: "Often 30–35 WPM English",
    stage: "Skill test when applicable",
    category: "Banking",
    intro: "Life Insurance Corporation recruitments for clerk, assistant, and AAO posts may include English typing skill tests where notified. Build speed with Typogram's free practice platform.",
    faqs: [
      { q: "Does LIC recruitment include typing test?", a: "When the LIC notification lists a skill test for clerk or assistant posts, typing may be qualifying. Read your official notice." },
      { q: "What WPM for LIC typing test?", a: "Prepare for 30–35 WPM in English with high accuracy and verify exact targets in your LIC advertisement." },
      { q: "How to prepare for LIC typing test?", a: "Practice 45–60 minutes daily on Typogram with English timed mocks." },
    ],
  },
};

export const EXAM_LANDING_SLUGS = Object.keys(EXAM_LANDING_PAGES);
